var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none",
  "data-coloringtype": "fill",
  viewBox: "0 0 21 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.9,
  d: "M3.106 13.158A8.503 8.503 0 0 0 19.5 10 8.5 8.5 0 0 0 2.874 7.5H7V9H0V2h1.5v4.869C2.814 2.879 6.57 0 11 0c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.21 0-7.813-2.602-9.287-6.285z"
})));
export default SvgReset;